import angular from "angular";
import {
  chartJsDirective,
  vsDirectiveName as chartJsDirectiveName,
} from "./directive";

export const vsModuleName = "SlotTrak.UI.Chart";

angular
  .module(vsModuleName, [])
  .directive(chartJsDirectiveName, chartJsDirective);